export const formatDateToStr = (date: Date) =>
    `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${(
        '0' + date.getDate()
    ).slice(-2)}`;

export const formatDateToLocalStr = (dateBase: string | Date) => {
    const date = typeof dateBase === 'string' ? new Date(dateBase) : dateBase;

    return `${('0' + date.getDate()).slice(-2)}.${('0' + (date.getMonth() + 1)).slice(
        -2,
    )}.${date.getFullYear()}`;
};
